import { useState } from 'react'
import './App.css'
import NewsSection from './NewsSection'
import SEO from './components/SEO'
import ShopSection from './components/ShopSection'

function App() {
  const [activeTab, setActiveTab] = useState('home')

  // Navigation items
  const navItems = [
    { id: 'tourism', label: 'Yacht Tours' },
    { id: 'sales', label: 'Yacht Sales' },
    { id: 'charter', label: 'Yacht Charter' },
    { id: 'dealers', label: 'Dealers' },
    { id: 'repair', label: 'Repair Services' },
    { id: 'marinas', label: 'Marinas' },
    { id: 'resources', label: 'Resources' }
  ]

  // Yacht Tours / Sea Activities data
  const yachtTours = [
    { name: 'Yacht Holimood', url: 'https://www.yacht.holimood.com/', description: 'Hong Kong\'s largest yacht charter platform' },
    { name: 'Oceangogo', url: 'https://www.oceangogo.com/', description: 'Customized sea trip services' },
    { name: 'Boat Market', url: 'https://www.boatmarket.com.hk/', description: 'Comprehensive yacht sales and charter platform' },
    { name: 'Deepsea Marine', url: 'https://www.deepseamarine.com/', description: 'One-stop yacht services including charters' },
    { name: 'Lantau Yacht Club', url: 'https://www.lantauyachtclub.com/', description: 'Premium private club with charter services' },
    { name: 'Royal Hong Kong Yacht Club', url: 'https://www.rhkyc.org.hk/', description: 'Historic yacht club with comprehensive services' }
  ]

  // Yacht Sales / Brokerage data
  const yachtSales = [
    { name: 'Boat Market', url: 'https://www.boatmarket.com.hk/', description: 'Comprehensive yacht sales platform' },
    { name: 'Deepsea Marine', url: 'https://www.deepseamarine.com/', description: 'Yacht sales and brokerage services' },
    { name: 'Simpson Marine', url: 'https://www.simpsonmarine.com/', description: 'International yacht brokerage with Hong Kong office' },
    { name: 'YachtWorld Asia', url: 'https://www.asia.yachtworld.com/', description: 'Global yacht sales platform with Asia focus' },
    { name: 'Boatbookings', url: 'https://www.boatbookings.com/', description: 'Global luxury yacht charter and sales' },
    { name: 'Fraser Yachts', url: 'https://www.fraseryachts.com/', description: 'Global full-service brokerage with Hong Kong office' }
  ]

  // Yacht Charter / Long-term Rental data
  const yachtCharter = [
    { name: 'Yacht Holimood', url: 'https://www.yacht.holimood.com/', description: 'Hong Kong\'s largest yacht charter platform' },
    { name: 'Oceangogo', url: 'https://www.oceangogo.com/', description: 'Customized sea trip and charter services' },
    { name: 'Deepsea Marine', url: 'https://www.deepseamarine.com/', description: 'One-stop yacht services including charters' },
    { name: 'Lantau Yacht Club', url: 'https://www.lantauyachtclub.com/', description: 'Premium private club with charter services' },
    { name: 'Royal Hong Kong Yacht Club', url: 'https://www.rhkyc.org.hk/', description: 'Historic yacht club with comprehensive services' }
  ]

  // Dealers / Brand Agents data
  const dealers = [
    { name: 'Simpson Marine', url: 'https://www.simpsonmarine.com/', description: 'Dealer for Princess, Sunseeker, Beneteau, etc.' },
    { name: 'Deepsea Marine', url: 'https://www.deepseamarine.com/', description: 'Dealer for various yacht brands' },
    { name: 'YachtWorld Asia', url: 'https://www.asia.yachtworld.com/', description: 'Platform for multiple brand dealers' },
    { name: 'Fraser Yachts', url: 'https://www.fraseryachts.com/', description: 'Global brokerage with new build agency' }
  ]

  // Repair Yards / Maintenance Services data
  const repairServices = [
    { name: 'Deepsea Marine', url: 'https://www.deepseamarine.com/', description: 'Comprehensive yacht repair and maintenance' },
    { name: 'Simpson Marine', url: 'https://www.simpsonmarine.com/', description: 'Yacht maintenance and after-sales service' },
    { name: 'Royal Hong Kong Yacht Club', url: 'https://www.rhkyc.org.hk/', description: 'Club facilities and maintenance services' },
    { name: 'Lantau Yacht Club', url: 'https://www.lantauyachtclub.com/', description: 'Premium club with maintenance facilities' }
  ]

  // Marinas / Moorings data
  const marinas = [
    { name: 'Royal Hong Kong Yacht Club', url: 'https://www.rhkyc.org.hk/', description: 'Historic club with marina facilities' },
    { name: 'Lantau Yacht Club', url: 'https://www.lantauyachtclub.com/', description: 'Premium club with marina facilities' },
    { name: 'Deepsea Marine', url: 'https://www.deepseamarine.com/', description: 'Marina and berthing services' },
    { name: 'Simpson Marine', url: 'https://www.simpsonmarine.com/', description: 'Marina and berthing arrangements' }
  ]

  // Other Resources data
  const otherResources = [
    { name: 'Hong Kong Marine Department', url: 'https://www.mardep.gov.hk/', description: 'Official maritime regulations and information' }
  ]

  return (
    <>
      <SEO 
        title="Yacht.hk - Hong Kong Yacht Navigation & Charter Services"
        description="Professional yacht services navigation platform for Hong Kong and Asia-Pacific region. Premium yacht charters and maritime services."
        keywords="yacht, Hong Kong, marine, sailing, boat charter, luxury yachts, Asia,游艇,香港,航海,租船,豪华游艇,亚洲"
        type="website"
      />
      <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-cyan-900 text-white py-6">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold mb-2">🚢 Yacht.hk - Hong Kong Yacht Navigation Website</h1>
          <p className="text-gray-300">Professional yacht services navigation platform for Hong Kong</p>
          <nav className="flex flex-wrap gap-3 mt-6">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="px-4 py-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors"
                onClick={(e) => {
                  e.preventDefault()
                  document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' })
                }}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        {/* Hero Section */}
        <section className="text-center py-12 bg-gradient-to-r from-cyan-50 to-blue-50 rounded-2xl mb-12">
          <h2 className="text-4xl font-bold text-cyan-800 mb-4">Hong Kong Yacht Services Navigation</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Comprehensive navigation platform for yacht services in Hong Kong, covering sales, charters, repairs, marinas, and tourism.
          </p>
          <div className="bg-red-500 text-white p-6 rounded-xl max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-3">🎉 Special Promotion!</h3>
            <p className="text-lg mb-2"><strong>Global Yacht Charter - 20% OFF!</strong></p>
            <p className="mb-2">Get 20% discount on all global yacht charters. Limited time offer!</p>
            <p><strong>Contact:</strong> info@yacht.hk</p>
          </div>
        <ShopSection />
        </section>

        {/* Yacht Tours / Sea Activities */}
        <section id="tourism" className="mb-12 bg-white p-8 rounded-2xl shadow-lg">
          <div className="border-b-2 border-cyan-600 pb-4 mb-8">
            <h2 className="text-3xl font-bold text-cyan-700">1. Yacht Tours / Sea Activities</h2>
            <p className="text-gray-600 mt-2">Short-term/day charters, parties, customized sea trips, and yacht tours</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {yachtTours.map((tour) => (
              <div key={tour.name} className="bg-cyan-50 p-6 rounded-xl border border-cyan-200">
                <h3 className="text-xl font-bold text-cyan-700 mb-3">
                  <a href={tour.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-900 hover:underline">
                    {tour.name}
                  </a>
                </h3>
                <p className="text-gray-700 mb-4">{tour.description}</p>
                <span className="inline-block bg-cyan-100 text-cyan-700 px-3 py-1 rounded text-sm">
                  {new URL(tour.url).hostname}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Yacht Sales / Brokerage */}
        <section id="sales" className="mb-12 bg-white p-8 rounded-2xl shadow-lg">
          <div className="border-b-2 border-cyan-600 pb-4 mb-8">
            <h2 className="text-3xl font-bold text-cyan-700">2. Yacht Sales / Brokerage</h2>
            <p className="text-gray-600 mt-2">New and used yacht sales, brokerage services</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {yachtSales.map((sale) => (
              <div key={sale.name} className="bg-cyan-50 p-6 rounded-xl border border-cyan-200">
                <h3 className="text-xl font-bold text-cyan-700 mb-3">
                  <a href={sale.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-900 hover:underline">
                    {sale.name}
                  </a>
                </h3>
                <p className="text-gray-700 mb-4">{sale.description}</p>
                <span className="inline-block bg-cyan-100 text-cyan-700 px-3 py-1 rounded text-sm">
                  {new URL(sale.url).hostname}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Yacht Charter / Long-term Rental */}
        <section id="charter" className="mb-12 bg-white p-8 rounded-2xl shadow-lg">
          <div className="border-b-2 border-cyan-600 pb-4 mb-8">
            <h2 className="text-3xl font-bold text-cyan-700">3. Yacht Charter / Long-term Rental</h2>
            <p className="text-gray-600 mt-2">Medium to long-term charters, corporate rentals, crewed management charters</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {yachtCharter.map((charter) => (
              <div key={charter.name} className="bg-cyan-50 p-6 rounded-xl border border-cyan-200">
                <h3 className="text-xl font-bold text-cyan-700 mb-3">
                  <a href={charter.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-900 hover:underline">
                    {charter.name}
                  </a>
                </h3>
                <p className="text-gray-700 mb-4">{charter.description}</p>
                <span className="inline-block bg-cyan-100 text-cyan-700 px-3 py-1 rounded text-sm">
                  {new URL(charter.url).hostname}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Dealers / Brand Agents */}
        <section id="dealers" className="mb-12 bg-white p-8 rounded-2xl shadow-lg">
          <div className="border-b-2 border-cyan-600 pb-4 mb-8">
            <h2 className="text-3xl font-bold text-cyan-700">4. Dealers / Brand Agents</h2>
            <p className="text-gray-600 mt-2">International yacht brand dealers and agents in Hong Kong</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {dealers.map((dealer) => (
              <div key={dealer.name} className="bg-cyan-50 p-6 rounded-xl border border-cyan-200">
                <h3 className="text-xl font-bold text-cyan-700 mb-3">
                  <a href={dealer.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-900 hover:underline">
                    {dealer.name}
                  </a>
                </h3>
                <p className="text-gray-700 mb-4">{dealer.description}</p>
                <span className="inline-block bg-cyan-100 text-cyan-700 px-3 py-1 rounded text-sm">
                  {new URL(dealer.url).hostname}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Repair Yards / Maintenance Services */}
        <section id="repair" className="mb-12 bg-white p-8 rounded-2xl shadow-lg">
          <div className="border-b-2 border-cyan-600 pb-4 mb-8">
            <h2 className="text-3xl font-bold text-cyan-700">5. Repair Yards / Maintenance Services</h2>
            <p className="text-gray-600 mt-2">Yacht repair, refit, haul-out, and maintenance services</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {repairServices.map((service) => (
              <div key={service.name} className="bg-cyan-50 p-6 rounded-xl border border-cyan-200">
                <h3 className="text-xl font-bold text-cyan-700 mb-3">
                  <a href={service.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-900 hover:underline">
                    {service.name}
                  </a>
                </h3>
                <p className="text-gray-700 mb-4">{service.description}</p>
                <span className="inline-block bg-cyan-100 text-cyan-700 px-3 py-1 rounded text-sm">
                  {new URL(service.url).hostname}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Marinas / Moorings */}
        <section id="marinas" className="mb-12 bg-white p-8 rounded-2xl shadow-lg">
          <div className="border-b-2 border-cyan-600 pb-4 mb-8">
            <h2 className="text-3xl font-bold text-cyan-700">6. Marinas / Moorings</h2>
            <p className="text-gray-600 mt-2">Yacht marinas, moorings, and berthing facilities in Hong Kong</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {marinas.map((marina) => (
              <div key={marina.name} className="bg-cyan-50 p-6 rounded-xl border border-cyan-200">
                <h3 className="text-xl font-bold text-cyan-700 mb-3">
                  <a href={marina.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-900 hover:underline">
                    {marina.name}
                  </a>
                </h3>
                <p className="text-gray-700 mb-4">{marina.description}</p>
                <span className="inline-block bg-cyan-100 text-cyan-700 px-3 py-1 rounded text-sm">
                  {new URL(marina.url).hostname}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Other Resources */}
        <section id="resources" className="mb-12 bg-white p-8 rounded-2xl shadow-lg">
          <div className="border-b-2 border-cyan-600 pb-4 mb-8">
            <h2 className="text-3xl font-bold text-cyan-700">7. Other Resources</h2>
            <p className="text-gray-600 mt-2">Additional yacht-related resources and information</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {otherResources.map((resource) => (
              <div key={resource.name} className="bg-cyan-50 p-6 rounded-xl border border-cyan-200">
                <h3 className="text-xl font-bold text-cyan-700 mb-3">
                  <a href={resource.url} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-900 hover:underline">
                    {resource.name}
                  </a>
                </h3>
                <p className="text-gray-700 mb-4">{resource.description}</p>
                <span className="inline-block bg-cyan-100 text-cyan-700 px-3 py-1 rounded text-sm">
                  {new URL(resource.url).hostname}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* News Section */}
        <NewsSection 
          website="yacht-hk"
          limit={10000}
          title="Hong Kong Yachting News"
          themeColor="cyan"
        />

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12 mt-12 rounded-2xl">
          <div className="container mx-auto px-4 text-center">
            <h3 className="text-2xl font-bold mb-4">Yacht.hk - Hong Kong Yacht Navigation</h3>
            <p className="text-gray-400 mb-6">Professional yacht services navigation platform for Hong Kong</p>
            <div className="flex flex-wrap justify-center gap-6 mb-8">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  className="text-gray-300 hover:text-white transition-colors"
                  onClick={(e) => {
                    e.preventDefault()
                    document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' })
                  }}
                >
                  {item.label}
                </a>
              ))}
            </div>
            <p className="text-gray-500">
              Contact: <a href="mailto:info@yacht.hk" className="text-cyan-400 hover:text-cyan-300">info@yacht.hk</a>
            </p>
            <p className="text-gray-500 mt-4">© {new Date().getFullYear()} Yacht.hk. All rights reserved.</p>
          </div>
        </footer>
      </main>
    </div>
    </>
  )
}

export default App